import { Divider, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';

interface BankDetailsSectionProps {
  titleId: string;
  children: React.ReactNode;
}

export function BankDetailsSection({ titleId, children }: BankDetailsSectionProps) {
  return (
    <div className='w-full rounded-2xl bg-white'>
      <div className='px-6 py-3'>
        <Typography.Text className='mb-0 text-lg font-bold leading-8'>
          <FormattedMessage id={titleId} />
        </Typography.Text>
      </div>
      <Divider className='my-0' />
      <div className='p-6'>{children}</div>
    </div>
  );
}
